export default "__VITE_ASSET__Bwpu8t7K__"